import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
/* global chessground */

import Board from '../shared/Board';

import NavButtons from '../shared/NavButtons';
import { CHESSJS } from '../constants/constants';
import { OpeningApi } from '../api/openingApi';
import { updateNavButtons } from '../actions/navButtons';
import { makeSanMoves } from '../util/chessHelper';
import OpeningCopyButton from './OpeningCopyButton';
import OpeningHeader from './OpeningHeader';

class Opening extends React.Component {
  constructor(props) {
    super(props);

    const { dispatch } = this.props;

    this.goTo = this.goTo.bind(this);
    this.openingApi = new OpeningApi(dispatch);
  }

  componentDidMount() {
    this.openingApi.show();
  }

  componentDidUpdate () {
    const { opening } = this.props;

    makeSanMoves(opening.san_moves)
  }

  goTo(moveNum) {
    const { dispatch, opening } = this.props;

    CHESSJS.load(opening.fen_moves[moveNum]);
    chessground.set({ fen: CHESSJS.fen() })

    dispatch(updateNavButtons(moveNum));
  }

  render() {
    const { opening } = this.props;
    const numMoves = opening.san_moves.length

    return (
      <div>
        <OpeningHeader />
        <div className="row align-items-center">
          <div className="col" />
          <div className="col-lg-6 col-md-12 col-sm-12 mr-3 mb-3">
            <Board />
            <div className="row p-2">
              <div className="col-2" />
              <div className="col p-2">
                <NavButtons goTo={this.goTo} first={0} last={numMoves} />
              </div>
            </div>
          </div>
           <div className="col-lg-4 col-md-9 col-sm-9">
             <div className="card">
              <div className="card-body">
                <div className="d-grid gap-2">
                  <OpeningCopyButton />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Opening.propTypes = {
  opening: PropTypes.shape({
    san_moves: PropTypes.arrayOf(PropTypes.string).isRequired,
    fen_moves: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  const { opening } = state;

  return { opening };
}

export default connect(mapStateToProps)(Opening);
